/**************************************************
 * Nombre:       Tarjeta_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import TituloTexto from "./Componentes/TituloTexto";
import {Feed} from '@mui/icons-material'
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Deposito from "../Dialogos/Dialogo_Deposito";
import {useEffect, useState} from "react";
import {calcularCuotas} from "../../CodNegocio/Cuotas/calcularCuotas";
import {formatoMoneda} from "../../Modulo_Wompi/Utilidades/formatoMoneda";
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import TituloCuentaRegresiva from "./Componentes/TituloCuentaRegresiva";
import {obtenerMesCuota} from "../../CodNegocio/Cuotas/obtenerMesCuota";
import {obtenerTotalAhorrado} from "../../CodNegocio/Bolsillo/obtenerTotalAhorrado";
import {obtenerNumCuotasPagas} from "../../CodNegocio/Cuotas/obtenerNumCuotasPagas";
import {obtenerFechaProximosDeposito} from "../../CodNegocio/Bolsillo/obtenerFechaProximosDeposito";


const Tarjeta_Deposito = ({alto = 212, item, recargar,setAntesDe}) => {
    const {Dialogo, abrir, cerrar} = useDialogo({
        Componente: Dialogo_Deposito,
        titulo: 'Datos del deposito',
        realizado: recargar
    })
    const [mesCuota, setMesCuota] = useState('')
    const [valorCuota, setValorCuota] = useState(0)
    const [fechaDeposito, setFechaDeposito] = useState(new Date())
    dayjs.locale('es');


    const obtenerDatos = async (valCuotaNormal) => {

        let totalAhorro = await obtenerTotalAhorrado({idBolsillo: item.id})
        console.log(totalAhorro)
        let mes = obtenerMesCuota({
            bolsillo: item,
            totalAhorro: totalAhorro,
            cuotaNormal: valCuotaNormal
        })
        setMesCuota(mes)
        let numCuotasPagas = obtenerNumCuotasPagas({totalAhorro: totalAhorro, cuotaNormal: valCuotaNormal})

        let valorCuota = calcularCuotas({
            meta: item.valor - totalAhorro,
            meses: item.numMeses - numCuotasPagas,
            tasaMensual: 1
        })
        setValorCuota(valorCuota)

        let fechaDep = obtenerFechaProximosDeposito({bolsillo: item, numCuotas: numCuotasPagas})

        setFechaDeposito(fechaDep)
        setAntesDe(dayjs(fechaDeposito).format('dddd DD - MMMM - YYYY'))

    }

    useEffect(() => {

        let cuos = calcularCuotas({meta: item.valor, meses: item.numMeses, tasaMensual: 1})

        obtenerDatos(cuos).then()


    }, []);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                p: 2,
                borderRadius: 4,
                color: '#000',
                minHeight: alto,
            }}
        >

            <Dialogo/>

            <Grid container size={11} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 600}}>Depositar</Typography>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', mt: 3}}>
                <TituloTexto titulo={'Valor a Depositar'} texto={formatoMoneda(valorCuota)} colorT={'#000000'}/>
            </Grid>

            <Grid container size={6} sx={{justifyContent: 'flex-start', mt: 3, mb: 0.3}}>
                <TituloCuentaRegresiva titulo={'Depositar antes de:'} fecha={fechaDeposito} dir={'flex-end'} textoS={18}
                                       mt={0.6} colorT={'#000000'}/>
            </Grid>

            <Grid container size={4} sx={{justifyContent: 'flex-start', mt: 2}}>
                <TituloTexto titulo={'Mes Correspondiente'}
                             texto={mesCuota.substring(0, 1).toUpperCase() + mesCuota.substring(1, dayjs().format('MMMM').length)}
                             textoS={20} colorT={'#000000'}/>
            </Grid>

            <Grid container size={8} sx={{justifyContent: 'flex-end', mt: 2}}>
                <Button
                    onClick={() => abrir({
                        mes: mesCuota.substring(0, 1).toUpperCase() + mesCuota.substring(1, dayjs().format('MMMM').length),
                        valor: valorCuota,
                        idBolsillo: item.id,
                        nombre: item.nombre
                    })}
                    color={'info'} startIcon={<Feed/>}>Iniciar Deposito</Button>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Deposito